/* Il riquadro di scelta delle colonne.
 *
 * Dal basso su telefono, centrato da 720px in su: è `Modale` che lo decide via
 * CSS, non un ramo JavaScript.
 *
 * Le tre fisse stanno in cima, spente al tocco ma accese a video, col motivo
 * scritto accanto. Toglierle dall'elenco avrebbe fatto sembrare che profitto e
 * drawdown si potessero perdere strada facendo.
 */

import { IconaSpunta, Pulsante } from '../../componenti';
import { Modale } from '../../componenti';
import {
  COLONNE,
  COLONNE_FISSE,
  quanteAccese,
  type ChiaveColonna,
  type SceltaColonne,
} from './colonne';

export function SelezioneColonne({
  aperta,
  onChiudi,
  scelta,
  onInverti,
  onAzzera,
}: {
  aperta: boolean;
  onChiudi: () => void;
  scelta: SceltaColonne;
  onInverti: (chiave: ChiaveColonna) => void;
  onAzzera: () => void;
}) {
  const accese = quanteAccese(scelta);

  return (
    <Modale
      aperta={aperta}
      onChiudi={onChiudi}
      titolo="Colonne"
      sottotitolo={`profitto, drawdown e operazioni restano sempre · ${accese} di ${COLONNE.length} opzionali accese`}
      pieda={
        <>
          <Pulsante variante="tenue" onClick={onAzzera}>
            Ripristina
          </Pulsante>
          <Pulsante variante="primario" largo onClick={onChiudi}>
            Fatto
          </Pulsante>
        </>
      }
    >
      <div className="sb-gr-colonne">
        {COLONNE_FISSE.map((c) => (
          <div key={c.etichetta} className="sb-gr-colonna-voce sb-gr-colonna-voce--bloccata">
            <span className="sb-gr-colonna-voce__spunta" aria-hidden="true">
              <IconaSpunta />
            </span>
            <span className="sb-gr-colonna-voce__corpo">
              <span className="sb-gr-colonna-voce__nome">{c.etichetta}</span>
              <span className="sb-gr-colonna-voce__nota">{c.nota}</span>
            </span>
          </div>
        ))}

        <hr className="sb-divisore" />

        {COLONNE.map((c) => {
          const on = scelta[c.chiave];
          return (
            <button
              key={c.chiave}
              type="button"
              role="switch"
              aria-checked={on}
              className={`sb-gr-colonna-voce${on ? ' sb-gr-colonna-voce--attiva' : ''}`}
              onClick={() => onInverti(c.chiave)}
            >
              <span className="sb-gr-colonna-voce__spunta" aria-hidden="true">
                {/* Lo spazio della spunta resta occupato anche da spenta: senza,
                    l'etichetta si sposta a ogni tocco. */}
                <span style={{ opacity: on ? 1 : 0, display: 'flex' }}>
                  <IconaSpunta />
                </span>
              </span>
              <span className="sb-gr-colonna-voce__corpo">
                <span className="sb-gr-colonna-voce__nome">{c.etichetta}</span>
                <span className="sb-gr-colonna-voce__nota">{c.nota}</span>
              </span>
            </button>
          );
        })}
      </div>
    </Modale>
  );
}
